export const versions = {
  version: "1.0.183",
  revision: "aa182e649",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5063-gaa182e649-dirty",
    hash: "gaa182e649",
    distance: 5063,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5063-gaa182e649-dirty",
    semverString: "1.0.183+5063.gaa182e649.dirty"
  }
};
